import React from "react";

export interface ConfirmDialogProps {
  show: boolean;
  onConfirm: (confirmed: boolean) => void;
  handleKeyDown: (e: React.KeyboardEvent, action: () => void) => void;
}

export function ConfirmDialog({
  show,
  onConfirm,
  handleKeyDown,
}: ConfirmDialogProps) {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-surface-800 border border-slate-700 rounded-lg p-6 max-w-md mx-4 shadow-xl">
        <div className="mb-4">
          <p className="text-md text-slate-100 mb-4">
            Have you downloaded your results? Starting a new cleanse will clear
            all current data.
          </p>
        </div>
        <div className="flex gap-3 justify-end">
          <button
            className="px-4 py-2 text-sm border border-slate-600 hover:bg-slate-700 text-slate-300 rounded focus:outline-hidden focus:ring-2 focus:ring-slate-400"
            onClick={() => onConfirm(false)}
            onKeyDown={(e) => handleKeyDown(e, () => onConfirm(false))}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 text-sm bg-green-600 hover:bg-green-500 text-white rounded focus:outline-hidden focus:ring-2 focus:ring-green-400"
            onClick={() => onConfirm(true)}
            onKeyDown={(e) => handleKeyDown(e, () => onConfirm(true))}
          >
            Yes, Start New
          </button>
        </div>
      </div>
    </div>
  );
}
